<i18n src="../../lib/i18n/product/locales.json"></i18n>

<template>
    <Row>
        <navbar :transparent="isTransparent"></navbar>
        <div class="iglobal">
            <div class="iglobal_main_page">
                <div class="detail_slide_1" ref="mybox">
                    <div style="position:absolute;top:40%;left: 0;right:0;bottom:0;">
                        <i-col span="24">
                            <div class="ichat_banner_title">iGlobal</div>
                            <p class="details_banner_text">
                                {{$t('iglobal_details_page_title')}}
                            </p>
                        </i-col>
                    </div>
                </div>
                <div class="layout-content" style="z-index: 1;">
                    <div class="Product-content mogos">
                        <div class="Product-content" style="background: #FFFFFF;padding:5% 0 5% 0;">
                            <Row style="padding:0 3% 0 3%">
                                <Col class="Product-left" :md="13" style="text-align: center;">
                                <img src="../../assets/store/iGlobal_card.png" class="mogos-logo">
                                </Col>
                                <Col class="Product-right" :md="11" style="text-align: left;">
                                <p class="Product-name">
                                    {{$t('iglobal_details_page_product_title')}}
                                </p>
                                <p class="Product-price">
                                    ${{goods_info.goods_price}}
                                </p>
                                <p class="Product-details">
                                    {{$t('iglobal_details_page_product_content')}}
                                </p>
                                <ul>
                                    <li class="Product-details-li">{{$t('iglobal_details_page_product_parameters1')}}
                                    </li>
                                    <li class="Product-details-li">{{$t('iglobal_details_page_product_parameters2')}}
                                    </li>
                                    <li class="Product-details-li">{{$t('iglobal_details_page_product_parameters3')}}
                                    </li>
                                </ul>
                                <buy :id="parseInt($route.params.id)"
                                     :maxCount="parseInt(goods_info.store_count)"></buy>

                                </Col>
                            </Row>
                        </div>

                        <div class="Product-content speedy">
                            <div style="background:rgba(31,45,61,0.3);padding:25px 0 25px 0;">
                                <Row style="" :gutter="30" class="details-card">
                                    <Col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                    <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                        <div style="text-align:center">
                                            <img src="../../assets/store/ichat_icon1.png">
                                            <span
                                                style="display: block;">{{$t('iglobal_details_page_advantage1_content1_1')}}</span>
                                            <span
                                                style="display: block;">{{$t('iglobal_details_page_advantage1_content1_2')}}</span>
                                        </div>
                                    </Card>
                                    </Col>
                                    <Col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                    <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                        <div style="text-align:center">
                                            <img src="../../assets/store/ichat_icon2.png">
                                            <span
                                                style="display: block;">{{$t('iglobal_details_page_advantage1_content2_1')}}</span>
                                            <span
                                                style="display: block;">{{$t('iglobal_details_page_advantage1_content2_2')}}</span>
                                        </div>
                                    </Card>
                                    </Col>
                                    <Col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                    <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                        <div style="text-align:center">
                                            <img src="../../assets/store/ichat_icon3.png">
                                            <span
                                                style="display: block;">{{$t('iglobal_details_page_advantage1_content3_1')}}</span>
                                            <span
                                                style="display: block;">{{$t('iglobal_details_page_advantage1_content3_2')}}</span>
                                        </div>
                                    </Card>
                                    </Col>

                                    <i-col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                        <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                            <div style="text-align:center">
                                                <img src="../../assets/store/ichat_icon4.png">
                                                <span
                                                    style="display: block;">{{$t('iglobal_details_page_advantage1_content4_1')}}</span>
                                                <span
                                                    style="display: block;">{{$t('iglobal_details_page_advantage1_content4_2')}}</span>
                                            </div>
                                        </Card>
                                    </i-col>
                                    <i-col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                        <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                            <div style="text-align:center">
                                                <img src="../../assets/store/ichat_icon5.png">
                                                <span
                                                    style="display: block;">{{$t('iglobal_details_page_advantage1_content5_1')}}</span>
                                                <span
                                                    style="display: block;">{{$t('iglobal_details_page_advantage1_content5_2')}}</span>
                                            </div>
                                        </Card>
                                    </i-col>
                                    <i-col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                        <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                            <div style="text-align:center">
                                                <img src="../../assets/store/ichat_icon6.png">
                                                <span
                                                    style="display: block;">{{$t('iglobal_details_page_advantage1_content6_1')}}</span>
                                                <span
                                                    style="display: block;">{{$t('iglobal_details_page_advantage1_content6_2')}}</span>
                                            </div>
                                        </Card>
                                    </i-col>
                                </Row>
                            </div>
                        </div>
                        <div style="clear: both"></div>
                        <div class="details_iapp_banner">
                            <i-col span="24">
                                <div class="layout-conten" id="iglobal_phone">
                                    <div class="swiper-container">
                                        <i-col :xs="24" :sm="{span:12,offset:12}" :md="{span:12,offset:11}"
                                               :lg="{span:12,offset:11}" style="position: absolute;top: 0;">
                                            <p class="details_iapp_text details_iapp_text1">
                                                {{$t('iglobal_details_advantage2')}}
                                            </p>
                                            <p class="details_iapp_text details_iapp_text2">
                                                {{$t('mogos_details_page_advantage2_content')}}
                                            </p>
                                        </i-col>
                                        <div class="swiper-wrapper">
                                            <div id="slider1" class="swiper-slide slider1" style="position: relative;">
                                            </div>
                                            <div id="slider2" class="swiper-slide slider2">
                                            </div>
                                            <div id="slider3" class="swiper-slide slider3">
                                            </div>
                                        </div>
                                        <!-- Add Pagination -->
                                        <div class="swiper-pagination">
                                        </div>
                                        <i-col span="12" offset="12">
                                            <p class="details_iapp_text"
                                               style="font-size: 50px;color: #1F2D3D;line-height: 78px;">
                                                {{$t('mogos_details_page_advantage2')}}
                                            </p>
                                            <p class="details_iapp_text"
                                               style="font-size: 22px;color: #5E6D82;line-height: 40px;">
                                                {{$t('mogos_details_page_advantage2_content')}}
                                            </p>
                                        </i-col>
                                    </div>
                                </div>
                                <div class="mobile-iglobal-phone" style="display: none">
                                    <p class="details_iapp_text details_iapp_text1">
                                        {{$t('mogos_details_page_advantage2')}}
                                    </p>
                                    <p class="details_iapp_text details_iapp_text2">
                                        {{$t('mogos_details_page_advantage2_content')}}
                                    </p>
                                    <div class="iglobal-step">
                                        <p class="Product-smname">1.{{$t('igobal_tip1')}}</p>
                                        <img src="../../assets/store/iglobal_phone_1_cn.jpg" alt="iglobal-step-1" v-if="this.mogosLang=='en' ">
                                        <img src="../../assets/store/iglobal_phone_1_en.png" alt="iglobal-step-1" v-else-if="this.mogosLang=='cn' ">
                                        <img src="../../assets/store/iglobal_phone_1_cn.jpg" alt="iglobal-step-1" v-else-if="this.mogosLang=='tc' ">
                                    </div>
                                    <div class="iglobal-step">
                                        <p class="Product-smname">2.{{$t('igobal_tip2')}}</p>
                                        <img src="../../assets/store/card_en.png" alt="iglobal-step-2" v-if="this.mogosLang=='en' ">
                                        <img src="../../assets/store/card_cn.png" alt="iglobal-step-1" v-else-if="this.mogosLang=='cn' ">
                                        <img src="../../assets/store/card_tc.png" alt="iglobal-step-1" v-else-if="this.mogosLang=='tc' ">
                                    </div>
                                    <div class="iglobal-step">
                                        <p class="Product-smname">3.{{$t('igobal_tip3')}}</p>
                                        <img src="../../assets/store/iglobal_phone_1.png" alt="iglobal-step-3" v-if="this.mogosLang=='en' ">
                                        <img src="../../assets/store/iglobal_phone_1_cn.png" alt="iglobal-step-1" v-else-if="this.mogosLang=='cn' ">
                                        <img src="../../assets/store/iglobal_phone_1_tc.png" alt="iglobal-step-1" v-else-if="this.mogosLang=='tc' ">
                                    </div>
                                </div>
                            </i-col>
                        </div>
                        <div style="clear: both"></div>
                        <div class="Product-content detials_purchase" style="padding:10% 3% 5% 3%;">
                            <Row style="max-width: 1200px;margin: 0 auto;">
                                <i-col class="Product-right" :md="13" style="text-align: left;">
                                    <p class="Product-name" style="color:#fff;padding-top: 20px;">
                                        {{$t('iglobal_details_page_advantage2')}}
                                    </p>
                                    <div class="Product-details" style="color:#fff;margin-top:30px;">
                                        <p>{{$t('iglobal_details_page_advantage2_content1')}}</p>
                                        <p>{{$t('iglobal_details_page_advantage2_content2')}}</p>
                                    </div>
                                    <button class="Product-btn" style="color:#fff;background-color:#ccc;border: none">
                                        {{$t('store_mainpage_out_of_stock')}}
                                    </button>
                                </i-col>
                                <i-col class="Product-left" :md="11" style="text-align: left;">
                                    <div class="iglobal_Cost">
                                        <h1>{{$t('iglobal_rate_tittle')}}</h1>
                                        <form>
                                            <div class="cost_input">
                                                <label>
                                                    {{$t('iglobal_rate_location')}}
                                                </label>
                                                <div class="cost_input_wrap">
                                                    <input type="text" v-model="from" name="from" placeholder="From"
                                                           v-on:input="inputFunc"/>
                                                    <ul v-show="fromShow">
                                                        <li v-for="(list,index) in from_list" :key="index"
                                                            @click="rate_from(list.name)">
                                                            <a>{{list.name}}</a>
                                                        </li>
                                                    </ul>
                                                </div>

                                            </div>
                                            <div class="cost_input">
                                                <label>
                                                    {{$t('iglobal_rate_destination')}}
                                                </label>
                                                <div class="cost_input_wrap">
                                                    <input type="text" name="to" v-model="to" placeholder="To"
                                                           v-on:input="inputTo"/>
                                                    <ul v-show="toShow">
                                                        <li v-for="(list,index) in to_list" :key="index"
                                                            @click="rate_to(list.name)">
                                                            <a>{{list.name}}</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </form>
                                        <div class="cost_btn">
                                            <button @click="GetRate">
                                                {{$t('iglobal_check')}}
                                            </button>
                                        </div>
                                        <h1>{{$t('iglobal_details')}}</h1>
                                        <div class="cost_result">
                                            <div class="cost_resule_item">
                                                <img src="../../assets/store/icon_receivecall@2x.png" width="50"/>
                                                <p class="cost_type">{{$t('iglobal_call')}}</p>
                                                <p class="cost_num" v-if="this.cost_data== '' ">00.00</p>
                                                <p class="cost_num" v-else>{{cost_data.Incoming}}</p>
                                                <p class="cost_data">/min</p>
                                            </div>
                                            <div class="cost_resule_item">
                                                <img src="../../assets/store/icon_call_out@2x.png" width="50"/>
                                                <p class="cost_type">{{$t('iglobal_callout')}}</p>
                                                <p class="cost_num" v-if="this.cost_data== '' ">00.00</p>
                                                <p class="cost_num" v-else>{{cost_data.Voice}}</p>
                                                <p class="cost_data">/min</p>
                                            </div>
                                            <div class="cost_resule_item">
                                                <img src="../../assets/store/icon_sms@2x.png" width="50"/>
                                                <p class="cost_type">{{$t('iglobal_sms')}}</p>
                                                <p class="cost_num" v-if="this.cost_data== '' ">00.00</p>
                                                <p class="cost_num" v-else>{{cost_data.SMS}}</p>
                                                <p class="cost_data">/sms</p>
                                            </div>
                                            <div class="cost_resule_item">
                                                <img src="../../assets/store/icon_data@2x.png" width="50"/>
                                                <p class="cost_type">{{$t('iglobal_data')}}</p>
                                                <p class="cost_num" v-if="this.cost_data== '' ">00.00</p>
                                                <p class="cost_num" v-else>{{cost_data.Data}}</p>
                                                <p class="cost_data">/1mb</p>
                                            </div>
                                        </div>
                                    </div>
                                </i-col>
                            </Row>
                        </div>

                        <div class="igo-product-details-footer">
                            <p style="color: #0084ff;">{{$t('shopping_notes')}}</p>
                            <p>{{$t('shopping_notes_tip')}}</p>
                        </div>
                        <div class="detail-basis max_width">
                            <guess></guess>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <BackTop>
            <div class="top">
                <img src="../../assets/backtop/top.png">
                <p style="">{{$t('top_btn')}}</p>
            </div>
        </BackTop>
        <a href="http://ifree.ly/support" target="_blank">
            <BackTop :height="100" :bottom="110">
                <div class="top">
                    <img src="../../assets/backtop/service.png">
                    <p>{{$t('Service_btn')}}</p>
                </div>
            </BackTop>
        </a>
    </Row>
</template>
<script>
    import Swiper from '../../../static/js/swiper-3.4.2.min'
    import navbar from '../Common/Navbar.vue'
    import buy from '../Common/Buy.vue'
    import guess from '../Profiler/Common/Guess.vue'
    import Signature from '../../lib/Signature'

    export default {
        data() {
            return {
                value1: 0,
                minus_text: 1,
                scroll: '',
                fromShow: false,
                toShow: false,
                active: false,
                mogosLang:'cn',
                num: 1,
                from: '',
                to: '',
                cost_data:[],
                from_list: [],
                to_list: [],
                goods_info: {},
                isTransparent: true,
                cost_data: []
            }
        },
        components: {
            navbar, buy, guess
        },
        created() {
            let module = 'index.php/index/goods/goodsinfo'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            data.lang = this.$config.defaults.l
            data.goods_id = this.$route.query.id
            this.$http.get(process.env.BASEURL + module, {
                params: data
            }).then(function (resp) {
                if (parseInt(resp.data.code) === 2000) {
                    this.goods_info = resp.data.data.goods_info
                }
            }.bind(this))
        },
        mounted () {
            window.addEventListener('scroll', this.init)
            var swiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                paginationClickable: true,
                direction: 'vertical',
                loop: false,
                speed: 1000,
                autoplay: false,
                mousewheelReleaseOnEdges: false,
                mousewheelControl: false,
                effect: 'fade',
                fade: {
                    crossFade: true,
                },
                onTouchEnd: function () {
                    swiper.startAutoplay()
                }
            })
            $('.swiper-pagination span:nth-of-type(1)').html("<p><span>1</span>" + this.$t('igobal_tip1') + "</p>")
            $('.swiper-pagination span:nth-of-type(2)').html("<p><span>2</span>" + this.$t('igobal_tip2') + "</p>")
            $('.swiper-pagination span:nth-of-type(3)').html("<p><span>3</span>" + this.$t('igobal_tip3') + "</p>"+"<div>"+this.$t('igobal_remark_text')+"</div>")

            this.lang = this.$i18n.locale
            if (this.lang === 'en-US') {
                $("#slider1").removeClass("slider1")
                $("#slider1").addClass("slider1_en")
                $("#slider1").removeClass("slider1_tc")
                $("#slider2").removeClass("slider2")
                $("#slider2").addClass("slider2_en")
                $("#slider2").removeClass("slider2_tc")
                $("#slider3").removeClass("slider3")
                $("#slider3").addClass("slider3_en")
                $("#slider3").removeClass("slider3_tc")
                this.mogosLang = 'en'
            }else if(this.lang === 'zh-CN'){
                this.mogosLang = 'cn'
                $("#slider1").removeClass("slider1_en")
                $("#slider1").addClass("slider1")
                $("#slider1").removeClass("slider1_tc")
                $("#slider2").removeClass("slider2_en")
                $("#slider2").addClass("slider2")
                $("#slider2").removeClass("slider2_tc")
                $("#slider3").removeClass("slider3_en")
                $("#slider3").addClass("slider3")
                $("#slider3").removeClass("slider3_tc")
            }else{
                this.mogosLang = 'tc'
                $("#slider1").removeClass("slider1_en")
                $("#slider1").addClass("slider1_tc")
                $("#slider1").removeClass("slider1")
                $("#slider2").removeClass("slider2_en")
                $("#slider2").addClass("slider2_tc")
                $("#slider2").removeClass("slider2")
                $("#slider3").removeClass("slider3_en")
                $("#slider3").addClass("slider3_tc")
                $("#slider3").removeClass("slider3")
            }
        },
        methods: {
            addShopCart (count) {
                this.addToCart(count)
            },
            tab (index) {
                this.num = index
            },
            buyNow() {
                this.$router.push({
                    name: 'Settlement',
                    query: {
                        goods_id: this.$route.params.id,
                        number: 1
                    }
                })
            },
            // 监控资费查询的to
            inputTo () {
                // 请求接口
                let module = 'index.php/iglobal/to'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                data.lang = this.$config.defaults.l
                data.key = this.to
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                }).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.to_list = resp.data.data
                        this.toShow = true
                    }
                }.bind(this))
            },
            // 监控资费查询的from
            inputFunc () {
                // 请求接口
                let module = 'index.php/iglobal/form'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                data.lang = this.$config.defaults.l
                data.key = this.from
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                }).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.from_list = resp.data.data
                        this.fromShow = true
                    }
                }.bind(this))
            },
            // from 点击获取国家
            rate_from (id) {
                this.from = id
                this.fromShow = false
            },
            // to 点击获取国家
            rate_to (id) {
                this.to = id
                this.toShow = false
            },
            //计算from到to的资费
            GetRate () {
                // 请求接口
                let module = 'index.php/iglobal/calculate'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                data.lang = this.$config.defaults.l
                data.from_number = this.from
                data.to_number = this.to
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                }).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.toShow = false
                        this.fromShow = false
                        this.cost_data = resp.data.data
                    }
                }.bind(this))
            }
        }

    }
</script>
<style lang="scss">
    @import '../../assets/css/swiper-3.4.2.min.css';
    .iglobal /deep/ .buy-components /deep/ .plus-minus,.iglobal /deep/ .buy-components /deep/ .add_cart{
        display: none;
    }
    .iglobal {
        perspective: 1px;
        padding: 0;
        height: 100%;
        overflow: auto;
        .detail_slide_1 {
            height: 100vh;
            background: url("../../assets/store/iglobal_pic1@2x.jpg") no-repeat center;
            background-size: cover;
            position: relative;
            overflow: hidden;
            max-height:760px;
            .ichat_banner_title {
                font-size: 120px;
                color: #FFFFFF;
            }
        }

        .speedy {
            background: url('../../assets/store/iglobal_pic2.jpg') no-repeat center;
            background-size: cover;

        }

        .Product-details-li {
            font-size: 16px;
            color: #5E6D82;
        }

        .details_banner_text {
            font-family: PingFangSC-Semibold;
            font-size: 22px;
            color: #FFFFFF;
            letter-spacing: 0;
            line-height: 40px;
            margin-top: -15px;
        }

        .mogos {
            position: relative;
        }

        .Product-name {
            font-size: 32px;
            color: #1F2D3D;
            line-height: 45px;
        }

        .igo-product-details-footer {
            text-align: left;
            width: 100%;
            margin: 0 auto;
            max-width: 1200px;
            padding: 30px 10px;
            font-size: 16px;
            color: #5E6D82;
        }

        .Product-price {
            font-size: 32px;
            color: #0084ff;
            line-height: 26px;
            margin: 3% 0 3% 0;
        }

        .Product-details {
            font-size: 16px;
            color: #5E6D82;
            letter-spacing: 0;
            line-height: 22px;
            padding: 0 20% 2% 0;
        }

        .Product-btn {
            border: 1px solid #0084FF;
            border-radius: 5px;
            height: 50px;
            width: 200px;
            font-size: 20px;
            color: #0084FF;
            background: transparent;
            margin: 5% 6% 0% 0%;
        }

        .Product-btn:hover {
            background: #0084FF;
            color: white;
            /*font-weight: 600;*/
        }
        #iglobal_phone {
            height: 700px;
            background: #FFF;
        }

        .Product-more {
            font-size: 16px;
        }

        .details_card_text {
            margin: 15px 0;
            .ivu-card-body{
                img{
                    margin-bottom: 10px;
                }
            }
        }

        .details_card_text div {
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            border-radius: 0 !important;
            padding: 15px 0;
        }
        .detail_country {
            margin-bottom: 5%;
        }

        .detail-button {
            margin-top: 12%;
        }

        /*backtop*/
        .swiper-container {
            width: 100%;
            height: 100%;
        }

        .swiper-slide {
            color: white;
            text-align: center;
            font-size: 18px;
            background: #fff;
            /* Center slide text vertically */
            display: -webkit-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: center;
        }

        /*slider-main-page*/
        .details_iapp_banner {
            height: 100vh;
            padding: 8% 0;
            max-width: 1300px;
            margin: 0 auto
        }

        .details_iapp_text {
            letter-spacing: 0;
        }

        .details_iapp_text1 {
            font-size: 32px;
            color: #1F2D3D;
            line-height: 78px;
        }

        .details_iapp_text2 {
            font-size: 20px;
            color: #5E6D82;
            line-height: 40px;
        }

        .details_iapp_banner .slider1 {
            background: url('../../assets/store/iglobal_phone_1_cn.jpg');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .slider1_en {
            background: url('../../assets/store/iglobal_phone_1_en.png');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .slider1_tc {
            background: url('../../assets/store/iglobal_phone_1_cn.jpg');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .slider2 {
            background: url('../../assets/store/card_cn.gif');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .slider2_en {
            background: url('../../assets/store/card_en.gif');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .slider2_tc {
            background: url('../../assets/store/card_cn.gif');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .slider3 {
            background: url('../../assets/store/iglobal_phone_1_cn.png');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .slider3_en {
            background: url('../../assets/store/iglobal_phone_1.png');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .slider3_tc {
            background: url('../../assets/store/iglobal_phone_1_tc.png');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .swiper-pagination-bullet {
            background: white;
        }

        .details_iapp_banner .swiper-container-vertical > .swiper-pagination-bullets {
            right: 40%;
            top: 35%;
        }

        .details_iapp_banner .swiper-pagination-bullet {
            width: 16px;
            height: 16px;
            font-size: 16px;
            margin-top: 2% !important;
            /*background: url("../../assets/store/.png") center;*/
            background-size: 100% 100%;
        }

        .details_iapp_banner .swiper-main {
            width: 35%;
            text-align: left;
            position: absolute;
            left: 50%;
        }

        .details_iapp_banner .swiper-main-title {
            margin: -15% 0 5% 0;
            font-size: 3em;
        }

        .details_iapp_banner .swiper-main-page {
            font-size: 17px;
            line-height: 26px;
        }

        .swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {
            margin: 20px 0;
        }

        .swiper-pagination span p{
            width: 600px;
            text-align: left;
            line-height: 24px;
        }
        .swiper-pagination div{
            width: 372px;
            text-align: center;
            font-size: 14px;
        }
        .swiper-pagination span p span {
            margin: 0 40px 0 5px;
            color: #fff;
            font-size: 14px;
        }

        .details_iapp_banner .swiper-pagination-bullet-active {
            background: url("../../assets/store/selected_right.png") center;
            background-size: 100% 100%;
            border-radius: 0 !important;
            width: 32px;
            height: 100%;
            color: #0084ff !important;
            font-size: 16px !important;
        }

        .details_global {
            color: #0084ff;
            border: 1px solid #0084ff;
            width: 120px;
            margin: 2%;
            font-size: 14px;
            background-color: #fff;
        }

        .details_global_active {
            color: #fff;
            background-color: #0084ff;
        }

        .details_global_active:hover {
            color: #fff;
            background-color: #0084ff;
        }

        .detials_purchase {
            background: url("../../assets/store/iglobal_pic4.jpg") center;
            background-size: cover;
            background-repeat: no-repeat;
            .Product-right {
                margin-top: 7.5%;
            }
            .Product-left {
                .iglobal_Cost {
                    width: 90%;
                    max-width: 420px;
                    margin: 6% auto;
                    background: #FFFFFF;
                    border-radius: 5px;
                    padding: 30px;
                    h1 {
                        font-family: PingFangSC-Medium;
                        font-size: 20px;
                        color: #1F2D3D;
                    }
                    .cost_input {
                        padding: 10px;
                        .cost_input_wrap {
                            position: relative;
                            ul {
                                width: 100%;
                                max-height: 500px;
                                overflow-y: scroll;
                                background: #ffffff;
                                position: absolute;
                                z-index: 11111;
                                top: 100%;
                                left: 0;
                                box-shadow: 2px 2px 5px 0 rgba(31, 45, 61, 0.2);
                                li {
                                    &:hover {
                                        background: #e6e6e6;
                                    }
                                    padding: 10px;
                                    line-height: 20px;
                                    font-size: 16px;
                                }
                            }
                        }
                        label {
                            font-size: 16px;
                            color: #1F2D3D;
                            letter-spacing: 0;
                        }
                        input {
                            width: 100%;
                            height: 45px;
                            margin-top: 10px;
                            font-size: 16px;
                            border: 1px solid #C0CCDA;
                            padding-left: 8px;
                        }
                    }
                    .cost_btn {
                        text-align: center;
                        margin: 20px 0;
                        button {
                            border: none;
                            font-family: PingFangSC-Medium;
                            font-size: 20px;
                            color: #FFFFFF;
                            letter-spacing: 0;
                            line-height: 40px;
                            width: 146px;
                            background: #0084FF;
                            border-radius: 5px;
                        }
                    }
                    .cost_result {
                        width: 100%;
                        display: flex;
                        margin-top: 15px;
                        .cost_resule_item {
                            width: 25%;
                            text-align: center;
                            .cost_type {
                                font-family: OpenSans-SemiBold;
                                font-size: 14px;
                                color: #1F2D3D;
                                margin: 5px 0;
                            }
                            .cost_num {
                                font-family: OpenSans-SemiBold;
                                font-size: 20px;
                                color: #0084FF;
                            }
                            .cost_data {
                                font-family: OpenSans-SemiBold;
                                font-size: 14px;
                                color: #1F2D3D;
                            }
                        }
                    }
                }
            }
        }

        /*滚动条*/

        .Product-tips {
            font-size: 50px;
            color: #FFFFFF;
            letter-spacing: 0;
            line-height: 78px;
            margin: 50px 0 20px 0;
        }

        .details-card {
            max-width: 1024px;
            width: 100%;
            margin: 10px auto !important;
            padding: 8% 0 8% 0;
        }

        @media screen and (max-width: 992px) {
            .Product-left, .Product-right {
                text-align: center !important;
            }
        }

        @media screen and (max-width: 768px) {
            .details_iapp_banner .swiper-slide {
                background-position: center !important;
                background-size: 45%;
            }
            #iglobal_phone {
                height: 929px;
                background: #FFF;
            }
            .swiper-pagination-bullet {
                display: none !important;
            }
            #slider1 {
                transform: translate3d(0, 0px, 0px) !important;
            }
            #slider2 {
                transform: translate3d(0, -900px, 0px) !important;
            }
            #slider3 {
                transform: translate3d(0, -1800px, 0px) !important;
            }
            .mogos-logo {
                width: 100%;
            }

            .details_banner_text {
                font-size: 16px;
            }

            .detail_slide_1 {
                .ichat_banner_title {
                    font-size: 45px;
                }
            }
            .Product-tips {
                font-size: 35px;
            }

            .details-card {
                width: 70%;
            }

            .Product-search {
                width: 100% !important;
                font-size: 20px;
            }

            .Product-btn {
                margin: 5% 0 0 0;
            }

            .detail_country {
                background: none;
            }

            .detail-button {
                padding: 100px 0;
            }

            .details_iapp_text1 {
                font-size: 32px;
                color: #1F2D3D;
                line-height: 78px;
            }

            .details_iapp_text2 {
                font-size: 20px;
                color: #5E6D82;
                line-height: 40px;
            }
        }

        @media screen and (max-width: 500px) {
            #iglobal_phone{
                display: none;
            }
            .mobile-iglobal-phone{
                display: block !important;
            }
            .iglobal-step{
                max-width: 300px;
                margin:20px auto;
                p{
                    margin:10px 0;
                    font-size: 16px;
                    color: #0084ff;
                }
                img{
                    width: 90%;
                }
            }
            .Product-details,.Product-details-li{
                font-size: 14px;
            }
            .detail_slide_1{
                background: url("../../assets/home/new_home/mobile_iglobal1.jpg")no-repeat center;
            }
            .details-card {
                width: 100%;
            }

            .Product-tips {
                font-size: 30px;
            }

            .detials_purchase {
                margin-top: 80px;
            }
            .details_iapp_banner .swiper-container-vertical > .swiper-pagination-bullets {
                display: none !important;
            }

            .Product-name, .details_iapp_text1 {
                font-size: 24px;
                line-height: 35px;
            }
            .details_iapp_text2 {
                font-size: 16px;
            }

            .details_iapp_banner .swiper-slide {
                background-position: center !important;
                background-size: 65%;
            }
        }

        @media screen and (max-width: 1000px) {
            .Product-details {
                padding: 0px 0% 2% 0px;
            }
        }

    }

    ::-webkit-scrollbar {
        width: 0px;
    }
</style>



// WEBPACK FOOTER //
// iglobal.vue?0ec43c88